import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.scss']
})
export class CompanySelectComponent {

  @Input() set preselectedCompany(newValue: number) {
    this.selectFromId(newValue);
  }

  @Input() companySelected: MultiselectItem[] = [];

  @Input() disabled: boolean = false;

  @Output() companySelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  list: MultiselectItem[] = [];

  preselectedId: number;

  constructor(
    public portalService: PortalService,
  ) {

    this.load();

  }

  onElementSelect(): void {
    this.companySelectedChange.emit(this.companySelected);
    this.onSelected.emit(this.companySelected);
  }

  load() {

    this.portalService.getMultiselectItems(Multiselect.COMPANY).subscribe((response) => {

      this.list = response?.data.map(company => {

        return {
          id: company.id,
          itemName: company.name
        } as MultiselectItem

      })

      if (this.preselectedId && this.companySelected.length == 0) {
        this.selectFromId(this.preselectedId);
      }

    },
    (error) => {
      console.log("errore", error);
    });

  }

  selectFromId(id: number, withEvent: boolean = true) {

    this.preselectedId = id;

    this.companySelected = this.list.filter(c => c.id == id);

    if (withEvent) {
      this.onElementSelect();
    }

  }

}
